import { selector } from "recoil";
import { baseSearchOptionsAtom } from "../atoms/baseSearchOptionsAtoms";

export const baseSearchOptionsSelector = selector({
  key: "baseSearchOptionsSelector",
  get: ({ get }) => {
    const data = get(baseSearchOptionsAtom);
    return data.baseSearchOptions;
  },
});
